import { Dispatch } from 'redux';
import headersBuilder, { Method } from '../../../utils/request';
import setLoadingStatus from '../setLoadingStatus';
import Errors from '../../../shared/validation/errors';

export interface IPrecalcFees {
  Id: number;
  AnticipatedRegularPerformanceFeeAmount: number;
  AnticipatedAnnualManagementFeeAmount: number;
  AnticipatedPerLotFeeAmount: number;
  AnticipatedPerDealFeeAmount: number;
  AnticipatedPammFeesSum: number;
  Currency: string;
}

export const PRECALC_FEES_LOADED = 'PRECALC_FEES_LOADED';

export type PrecalcFeesLoadedAction = {
  type: string;
  precalcFeesState: IPrecalcFees;
};

export const precalcFeesLoaded = (data: IPrecalcFees): PrecalcFeesLoadedAction => ({
  type: PRECALC_FEES_LOADED,
  precalcFeesState: data
});

function fetchPrecalcFees(api: string, investorId: string) {
  return (dispatch: Dispatch): void => {
    dispatch(setLoadingStatus(true));

    fetch(`${api}/investors/anticipatedFees/${investorId}`, headersBuilder(Method.GET))
      .then((response: Response) => Errors.checkResponseForErrors(response, api))
      .then((data: any) => {
        dispatch(precalcFeesLoaded(data));
      })
      .catch((error: Error) => {
        Errors.throwErrorMessage(error);
      })
      .finally(() => {
        dispatch(setLoadingStatus(false));
      });
  };
}

export default fetchPrecalcFees;
